import React from "react";
import styles from "../styles/Privacy.module.css";
import Header from "./Header";
import Footer from "./Footer";

export default function Privacy() {
  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <h1>Privacy Policy</h1>

        <p className={styles.updated}>
          Last updated: August 30, 2026
        </p>

        <p>
          At PaySlipMadeSimple, we respect your privacy. This Privacy Policy
          explains what information is processed when you use our website,
          how it is used, and your rights regarding your personal data.
        </p>

        <h2>1. Who We Are</h2>

        <p>
          PaySlipMadeSimple is operated by CyTechSharp. The website provides
          a free online payslip calculator and payslip PDF generation tool,
          primarily intended for use with Cyprus payroll calculations.
        </p>

        <p>
          For privacy-related questions or requests, you can contact us at:
        </p>

        <p>
          <strong>Email:</strong> YOUR-PRIVACY-EMAIL@example.com
        </p>

        <h2>2. Information You Enter</h2>

        <p>
          PaySlipMadeSimple allows you to enter information such as employer
          details, employee details, salary information, tax information,
          payment information, deductions, and notes in order to calculate
          payroll amounts and generate a payslip.
        </p>

        <p>
          The payroll calculations and PDF generation are performed locally
          in your web browser. We do not operate a backend database that
          stores the payroll information you enter into the calculator.
        </p>

        <p>
          You should nevertheless avoid entering information that you do not
          need for the calculation or payslip you are creating.
        </p>

        <h2>3. Local Storage and Cookies</h2>

        <p>
          The website uses first-party cookies to save certain form
          information on your device so that previously entered information
          can be restored when you return to the website.
        </p>

        <p>
          These cookies are used for the functionality of the calculator and
          are not used by PaySlipMadeSimple to create a server-side database
          of your payroll information.
        </p>

        <p>
          The website does not currently store your completed payroll data on
          our own servers.
        </p>

        <p>
          You can delete cookies through your browser settings. Deleting or
          blocking cookies may cause previously saved form information to be
          lost or may affect some website functionality.
        </p>

        <h2>4. What We Do Not Currently Store</h2>

        <p>
          PaySlipMadeSimple does not currently maintain a server-side account
          or database containing the employee and employer information entered
          into the calculator.
        </p>

        <p>
          Generated payslips are created in your browser and downloaded to
          your device. We do not receive a copy of the generated PDF through
          the calculator.
        </p>

        <h2>5. Third-Party Services and Advertising</h2>

        <p>
          We may use third-party services in the future, including advertising,
          analytics, security, hosting, or other website functionality.
        </p>

        <p>
          These services may process certain information about visitors,
          including technical information such as IP address, browser type,
          device information, approximate location, and information about
          interactions with the website.
        </p>

        <p>
          Where required by applicable law, we will request consent before
          using non-essential cookies or similar technologies.
        </p>

        <p>
          Third-party providers may have their own privacy policies governing
          how they process information.
        </p>

        <h2>6. Advertising</h2>

        <p>
          PaySlipMadeSimple may display advertisements in order to keep the
          calculator available to users free of charge.
        </p>

        <p>
          Advertising providers may use cookies or similar technologies to
          provide, measure, personalize, or improve advertising, depending on
          the services and configuration used by the website.
        </p>

        <p>
          We will update this Privacy Policy and our cookie controls when
          advertising services are introduced to the website.
        </p>

        <h2>7. Data Security</h2>

        <p>
          We take reasonable technical and organisational measures to protect
          information processed through the website.
        </p>

        <p>
          However, no website or internet transmission can be guaranteed to
          be completely secure. You should therefore avoid entering
          unnecessary sensitive information into the calculator.
        </p>

        <h2>8. Your GDPR Rights</h2>

        <p>
          If the GDPR applies to the processing of your personal data, you may
          have rights including the right to access, rectify, erase, restrict
          processing, object to certain processing, and receive your personal
          data in a portable format where applicable.
        </p>

        <p>
          You may also have the right to withdraw consent where processing is
          based on consent. Withdrawal of consent does not affect the
          lawfulness of processing carried out before consent was withdrawn.
        </p>

        <p>
          These rights are subject to the conditions and exceptions provided
          by applicable law.
        </p>

        <h2>9. How to Exercise Your Rights</h2>

        <p>
          If you have a privacy request or question, contact us using the
          contact details provided above. We may need sufficient information
          to verify your identity before responding to certain requests.
        </p>

        <h2>10. Children's Privacy</h2>

        <p>
          PaySlipMadeSimple is not specifically directed at children. We do
          not knowingly seek to collect personal information from children.
        </p>

        <h2>11. Changes to This Privacy Policy</h2>

        <p>
          We may update this Privacy Policy from time to time to reflect
          changes to the website, services, technology, advertising providers,
          or applicable legal requirements.
        </p>

        <p>
          The updated version will be published on this page with a revised
          "Last updated" date.
        </p>

        <h2>12. Contact</h2>

        <p>
          If you have questions about this Privacy Policy or the way
          PaySlipMadeSimple processes information, please contact:
        </p>

        <p>
          <strong>CyTechSharp</strong>
          <br />
          sharpdevelopmentcy@gmail.com
        </p>
      </div>
    </main>
  );
}